import { styled } from "@mui/material";
import moment from "moment";

// Shared styled component
export const VisuallyHiddenInput = styled("input")`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

export const validateReimbursementRequest = (
  data: { amount: number; confirmation: boolean; understanding: boolean },
  files: Array<{ name: string; path: string; type: string }>,
  amountRemaining: number,
  hasBankAccount: boolean,
  notifications: { error: (message: string) => void }
) => {
  if (files.length === 0) {
    notifications.error("At least one file attachment is required.");
    return false;
  }

  if (data.amount <= 0 || data.amount > amountRemaining) {
    notifications.error("Please enter an amount between 0 and the remaining benefit amount.");
    return false;
  }

  if (!data.confirmation) {
    notifications.error("Please confirm that the information provided is true and correct.");
    return false;
  }

  if (!hasBankAccount && !data.understanding) {
    notifications.error("Please acknowledge the bank account requirement.");
    return false;
  }

  return true;
};

/**
 * Returns an array of months in 'YYYY-MM' format, starting N months before now and ending M months after now (inclusive).
 */
export function getMonthRange(before: number, after: number): string[] {
  const months: string[] = [];
  const start = moment().subtract(before, "months");
  for (let i = 0; i < before + after + 1; i++) {
    months.push(start.clone().add(i, "months").format("YYYY-MM"));
  }
  return months;
} 